import { TextStyle } from '@coast/schemas';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { AddressValue } from '../../types';
import { getTextPropsFromTextStyle } from '../../utils';
import { GeolocationMapPreview } from '../inputGeolocation/mapPreview';

interface Props {
  textStyle?: TextStyle;
  address: AddressValue;
  onClear?(): void;
}

export function AddressContent({ textStyle, address, onClear }: Props) {
  const textProps = getTextPropsFromTextStyle(textStyle);
  return (
    <>
      <View paddingBottom={0.5}>
        <Text {...textProps}>{address.title}</Text>
        <Text {...textProps} inactive>
          {address.subtitle}
        </Text>
      </View>
      <GeolocationMapPreview
        lat={address.coords.lat}
        lon={address.coords.lon}
        iconUrl="https://assets.coastapp.com/address-pin.png"
        onClear={onClear}
      />
    </>
  );
}
